import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

class ProductDiscount extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDiscount);
  }

  /**
   * Updates the discount value on variant change.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDiscount = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDiscount = event.detail.data.html.querySelector(`product-discount[data-block-id="${this.dataset.blockId}"]`);

    if (!newDiscount) return;

    // Keep root attributes in sync so hidden/visible state always updates.
    this.className = newDiscount.className;
    this.setAttribute('style', newDiscount.getAttribute('style') ?? '');

    const newDiscountText = newDiscount.querySelector('[ref="discountText"]');
    const currentDiscountText = this.querySelector('[ref="discountText"]');

    if (newDiscountText && currentDiscountText) {
      currentDiscountText.textContent = newDiscountText.textContent;
    } else {
      this.innerHTML = newDiscount.innerHTML;
    }
  };
}

if (!customElements.get('product-discount')) {
  customElements.define('product-discount', ProductDiscount);
}
